import { Grid, Typography, Paper, Box, Chip } from '@mui/material';

const MeasurementTab = ({ behavior }) => (
  <Grid container spacing={3}>
    <Grid item xs={12}>
      <Typography variant='subtitle1' gutterBottom>
        Measurement Configuration
      </Typography>
      <Paper variant='outlined' sx={{ p: 2, mb: 2 }}>
        <Typography variant='subtitle2' gutterBottom>
          Measurement Types
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {behavior?.info?.DataCollection?.measurementType?.Type?.length > 0 ? (
            behavior.info.DataCollection.measurementType.Type.map(
              (type, index) => (
                <Chip key={index} label={type} size='small' sx={{ bgcolor: '#e9eaff' }} />
              )
            )
          ) : (
            <Typography variant='body2' color='text.secondary'>
              Not specified
            </Typography>
          )}
        </Box>
      </Paper>
    </Grid>
  </Grid>
);

export default MeasurementTab;

